import styled from "styled-components";
import { size } from "styled-theme";

export const Wrapper = styled.div`
  min-height: 100%;
  margin-bottom: -81px;

  &.extend-footer {
    margin-bottom: -157px;
  }

  @media only screen and (max-width: ${size("S")}) {
    margin-bottom: -111px;
   
    &.extend-footer {
      margin-bottom: -187px;
    }
  }
`;
